










import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { FormGroup } from '@/shared/forms/form-group'

@Component({
  inject: ['form'],
})
export default class UnifyListItemLabel extends Vue {
  @Prop({
    type: String,
  })
  public readonly control!: string

  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly validatePristine!: boolean

  public readonly form!: FormGroup<any>

  public get dirty() {
    return this.validatePristine === true || this.formControl.$dirty
  }

  public get formControl() {
    return this.form.field(this.control)
  }

  public get invalid() {
    return this.dirty && this.formControl.$invalid
  }

  public get required() {
    return this.formControl.hasOwnProperty('required')
  }
}
